export default __webpack_public_path__ + "../img/9bd843b4aa9385f2db4c19687213f3d8.svg";